export let PaymentMethodTypes;

(function (PaymentMethodTypes) {
  PaymentMethodTypes["BankAccount"] = "bankAccount";
  PaymentMethodTypes["PlaidBankAccount"] = "plaidBankAccount";
  PaymentMethodTypes["CreditCard"] = "creditCard";
})(PaymentMethodTypes || (PaymentMethodTypes = {}));

export let BankAccountStatusTypes;

(function (BankAccountStatusTypes) {
  BankAccountStatusTypes["New"] = "new";
  BankAccountStatusTypes["Validated"] = "validated";
  BankAccountStatusTypes["Verified"] = "verified";
  BankAccountStatusTypes["VerificationFailed"] = "verification_failed";
  BankAccountStatusTypes["TwoAttemptsFailed"] = "twoAttemptsFailed";
  BankAccountStatusTypes["PlaidVerification"] = "plaidVerification";
  BankAccountStatusTypes["PlaidVerificationFailed"] = "plaidVerificationFailed";
  BankAccountStatusTypes["FailedDueToDuplicate"] = "failed_due_to_duplicate";
})(BankAccountStatusTypes || (BankAccountStatusTypes = {}));

export let PlaidBankAccountStatusTypes;

(function (PlaidBankAccountStatusTypes) {
  PlaidBankAccountStatusTypes["PendingAutomaticVerification"] = "pending_automatic_verification";
  PlaidBankAccountStatusTypes["PendingManualVerification"] = "pending_manual_verification";
  PlaidBankAccountStatusTypes["AutomaticallyVerified"] = "automatically_verified";
  PlaidBankAccountStatusTypes["ManuallyVerified"] = "manually_verified";
  PlaidBankAccountStatusTypes["VerificationExpired"] = "verification_expired";
  PlaidBankAccountStatusTypes["VerificationFailed"] = "verification_failed";
})(PlaidBankAccountStatusTypes || (PlaidBankAccountStatusTypes = {}));

export let VerifyWithEnum;

(function (VerifyWithEnum) {
  VerifyWithEnum["Plaid"] = "plaid";
  VerifyWithEnum["Stripe"] = "stripe";
  VerifyWithEnum["None"] = "none";
})(VerifyWithEnum || (VerifyWithEnum = {}));